/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryResponseDto
 */
export interface CountryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CountryResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponseDto
     */
    iso: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponseDto
     */
    emoji: string;
}

/**
 * Check if a given object implements the CountryResponseDto interface.
 */
export function instanceOfCountryResponseDto(value: object): value is CountryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('iso' in value) || value['iso'] === undefined) return false;
    if (!('emoji' in value) || value['emoji'] === undefined) return false;
    return true;
}

export function CountryResponseDtoFromJSON(json: any): CountryResponseDto {
    return CountryResponseDtoFromJSONTyped(json, false);
}

export function CountryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iso': json['iso'],
        'emoji': json['emoji'],
    };
}

export function CountryResponseDtoToJSON(json: any): CountryResponseDto {
    return CountryResponseDtoToJSONTyped(json, false);
}

export function CountryResponseDtoToJSONTyped(value?: CountryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'iso': value['iso'],
        'emoji': value['emoji'],
    };
}

